// @flow

export const setFocus = (form: HTMLFormElement, field: string) => {
  // $FlowIgnore: fields getters are not typesafe
  const elem = form.elements[field];
  if (elem && elem.focus) {
    elem.focus();
  }
};

export const autofocus = (node: any) => {
  if (node !== null && typeof node.focus === 'function') {
    node.focus();
  }
};

export const range = (length: number, offset: number = 0): Array<number> =>
  // $FlowIgnore Array.apply is not an Array static...
  Array.apply(0, Array(length)).map((_, i) => i + offset);

export const months = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export const currentDate = () => {
  const d = new Date();
  return {
    day: d.getDate(),
    month: d.getMonth(),
    year: d.getFullYear(),
  };
};

export const states = [
  'AL',
  'AK',
  'AZ',
  'AR',
  'CA',
  'CO',
  'CT',
  'DE',
  'FL',
  'GA',
  'HI',
  'ID',
  'IL',
  'IN',
  'IA',
  'KS',
  'KY',
  'LA',
  'ME',
  'MD',
  'MA',
  'MI',
  'MN',
  'MS',
  'MO',
  'MT',
  'NE',
  'NV',
  'NH',
  'NJ',
  'NM',
  'NY',
  'NC',
  'ND',
  'OH',
  'OK',
  'OR',
  'PA',
  'RI',
  'SC',
  'SD',
  'TN',
  'TX',
  'UT',
  'VT',
  'VA',
  'WA',
  'WV',
  'WI',
  'WY',
];

export const cityState = ({
  city,
  stateabbreviation: state,
}: {
  city: string | null,
  stateabbreviation: string | null,
}) =>
  city && state
    ? `${city.trim()}, ${state.trim()}`
    : (city || state || '').trim();

const identity = i => i;
export const sortBy = (prop: string, reify: * = identity) => (
  o1: Object,
  o2: Object
): number => {
  const a = reify(o1[prop]);
  const b = reify(o2[prop]);
  if (a < b) {
    return -1;
  }
  if (a > b) {
    return 1;
  }
  return 0;
};

export const retry = (fn: Function, maxRetry: number, retries: number = 0) =>
  fn(retries).catch(e => {
    if (retries >= maxRetry) throw e;

    return retry(fn, maxRetry, retries + 1);
  });



// WEBPACK FOOTER //
// ./src/utils/index.js